import { Injectable } from '@angular/core';
import { UserData } from '../../../../providers/user-data'; 
import { PageRef } from '../../../../core/core.module';
import firebase from 'firebase';

@Injectable()
export class ShoppingListCommon {
	public realtimeDb: any;
	constructor(
		public userData: UserData,
    	public pageRef: PageRef,

	) {
		this.realtimeDb = firebase.database();
	}

	public commonMethod(){
		console.log("Hello Shopping List Page");
	}

}



// WEBPACK FOOTER //
// ./src/modules/account/pages/shopping-list/shopping-list.common.ts